// API functions for news system
import apiClient from './index';

// Posts CRUD operations
export const getPosts = async (params = {}) => {
  const { skip = 0, limit = 10, roleId = null } = params;
  let url = `/adss/v1/news/posts?skip=${skip}&limit=${limit}`;
  
  if (roleId !== null) {
    url += `&role_id=${roleId}`;
  }
  
  console.log('Making GET request to:', url);
  try {
    const response = await apiClient.get(url);
    console.log('Got response from news posts:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching posts:', error);
    throw error;
  }
};

export const getPost = async (postId) => {
  console.log(`Making GET request to: /adss/v1/news/posts/${postId}`);
  try {
    const response = await apiClient.get(`/adss/v1/news/posts/${postId}`);
    console.log('Got response for post:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Error fetching post ${postId}:`, error);
    throw error;
  }
};

export const createPost = async (postData) => {
  console.log('Making POST request to: /adss/v1/news/posts with data:', postData);
  try {
    const response = await apiClient.post('/adss/v1/news/posts', postData);
    console.log('Got response for create post:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error creating post:', error);
    throw error;
  }
};

export const updatePost = async (postId, postData) => {
  console.log(`Making PUT request to: /adss/v1/news/posts/${postId} with data:`, postData);
  try {
    const response = await apiClient.put(`/adss/v1/news/posts/${postId}`, postData);
    console.log('Got response for update post:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Error updating post ${postId}:`, error);
    throw error;
  }
};

export const deletePost = async (postId) => {
  console.log(`Making DELETE request to: /adss/v1/news/posts/${postId}`);
  try {
    const response = await apiClient.delete(`/adss/v1/news/posts/${postId}`);
    console.log('Got response for delete post:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Error deleting post ${postId}:`, error);
    throw error;
  }
};

// Attachments operations
export const uploadAttachment = async (postId, file) => {
  console.log(`Making POST request to: /adss/v1/news/posts/${postId}/attachments with file:`, file.name);
  const formData = new FormData();
  formData.append('file', file);
  
  try {
    const response = await apiClient.post(
      `/adss/v1/news/posts/${postId}/attachments`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    console.log('Got response for upload attachment:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Error uploading attachment to post ${postId}:`, error);
    throw error;
  }
};

export const deleteAttachment = async (postId, attachmentId) => {
  console.log(`Making DELETE request to: /adss/v1/news/posts/${postId}/attachments/${attachmentId}`);
  try {
    const response = await apiClient.delete(
      `/adss/v1/news/posts/${postId}/attachments/${attachmentId}`
    );
    console.log('Got response for delete attachment:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Error deleting attachment ${attachmentId} from post ${postId}:`, error);
    throw error;
  }
};

export const getAttachmentUrl = (postId, filename) => {
  return `${apiClient.defaults.baseURL}/adss/v1/news/attachments/${postId}/${filename}`;
};